import React from 'react'

import { useAuth } from '../../AuthContext'
function TwitterAuth() 
{


    const myContext = useAuth()

const TWITTER_CLIENT_ID = "N2p2TE94QzMxMHR1UGUzb1JGX3c6MTpjaQ";
const REDIRECT_URI = "https://schedpilot.com/wp-json/api/v1/callback-twitter";
const SCOPE = "tweet.read tweet.write media.write users.read offline.access";


function generateRandomString(length = 43) {
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const array = new Uint32Array(length);
  window.crypto.getRandomValues(array);

  for (let i = 0; i < length; i++) {
    result += charset[array[i] % charset.length];
  }

  return result;
} 

 const getTwitterAuthUrl = () => {
  const state = generateRandomString(56);
  const codeVerifier = generateRandomString(54); // Same as challenge for method 'plain'

  // Save for callback verification
  localStorage.setItem('twitter_oauth_state', state);
  localStorage.setItem('twitter_code_verifier', codeVerifier);

  // Use x.com (not twitter.com): users are logged into x.com, and the old
  // twitter.com domain no longer reliably shares the session cookie — sending
  // them to twitter.com makes X treat them as logged out and bounces them to
  // /i/flow/login ("Redirect is requested").
  const url = `https://x.com/i/oauth2/authorize?` +
    `response_type=code&` +
    `client_id=${encodeURIComponent(TWITTER_CLIENT_ID)}&` +
    `redirect_uri=${encodeURIComponent(REDIRECT_URI)}&` +
    `scope=${encodeURIComponent(SCOPE)}&` +
    `state=${encodeURIComponent(state)}&` +
    `code_challenge=${encodeURIComponent(codeVerifier)}&` +
    `code_challenge_method=plain`;

  return url;
};

 


const handleConnectX = () => 
{

const xurl = getTwitterAuthUrl();
const width = 600, height = 600;
        const left = (window.innerWidth - width) / 2;
        const top = (window.innerHeight - height) / 2;
    
      let authWindow = window.open(
            xurl,
            'X Auth',
            `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=no, width=${width}, height=${height}, top=${top}, left=${left}`
        );
        


       // let authWindow = window.open(xurl, '_blank');
 

         const jwtToken2 = myContext.jwtToken;
        
                window.addEventListener("message", event => {

                //    console.log("event")
               //     console.log(event.data)

                    
          if (event.data.type == "xtwitter-authenticated2") {

            myContext.getAccountsData();
            //myContext.settwitterconnected(true);
            //console.log("xtwitter-authenticated2")
             if (authWindow) authWindow.close();
        }
 

            if (event.data.type == "xtwitter-authenticated") {
 
 
                const theCode = event.data.code;                
               
            
                if (authWindow) authWindow.close();

                authWindow = window.open(
            "https://api.schedpilot.com/wp-json/api/v1/token-exchange-twitter/?code=" + theCode + "&codeVerifier=" + localStorage.getItem('twitter_code_verifier') + "&jwtToken=" + jwtToken2,
            'X Auth',
            `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=no, width=${width}, height=${height}, top=${top}, left=${left}`
        );

  
   
     
            }
        });
    
    
 



    }
 




  return (
    <>
      <button className='btn btn-primary' onClick={handleConnectX}> 
      <p className='p-0 m-0'>Connect X/Twitter</p></button>
    </>
  )
}

export default TwitterAuth
